import React, { useEffect, useMemo, useState } from 'react';
import { API_ENDPOINTS } from '../config/api';

const DashboardMail = ({ userType, user }) => {
  const fromEmail = useMemo(() => (
    user?.email || `${user?.username || user?.id}@creativetown.ng`
  ).toLowerCase(), [user]);
  const [messages, setMessages] = useState([]);
  const [form, setForm] = useState({ to: '', subject: '', text: '' });
  const [notice, setNotice] = useState('');

  const loadMail = () => {
    if (!user) return;
    fetch(`${API_ENDPOINTS.BASE_URL}/api/mail/${userType}/${encodeURIComponent(user.username || user.id)}?email=${encodeURIComponent(fromEmail)}`)
      .then(response => response.ok ? response.json() : [])
      .then(setMessages)
      .catch(() => setMessages([]));
  };

  useEffect(loadMail, [userType, user, fromEmail]);

  const send = async () => {
    setNotice('');
    const response = await fetch(`${API_ENDPOINTS.BASE_URL}/api/mail/send`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ ...form, from: fromEmail, senderType: userType, senderId: user?.username || user?.id })
    });
    const data = await response.json();
    if (!response.ok) return setNotice(data.error || 'Unable to send mail');
    setNotice(data.message.delivery?.success ? 'Mail sent.' : 'Mail saved in dashboard; external delivery is not configured.');
    setForm({ to: '', subject: '', text: '' });
    loadMail();
  };

  return (
    <section className="bg-white rounded-2xl shadow-lg border border-slate-200 p-5 my-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-4">
        <div>
          <p className="text-emerald-700 font-black uppercase text-sm">Creative Town Mail</p>
          <h2 className="text-2xl font-black text-slate-900">{fromEmail}</h2>
        </div>
        <span className="bg-slate-100 text-slate-700 px-3 py-2 rounded-lg font-bold">{messages.length} messages</span>
      </div>
      {notice && <p className="mb-3 text-sm font-semibold text-amber-700">{notice}</p>}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="space-y-3">
          <input className="w-full border rounded-lg px-3 py-2" placeholder="recipient@creativetown.ng" value={form.to} onChange={e => setForm({ ...form, to: e.target.value })} />
          <input className="w-full border rounded-lg px-3 py-2" placeholder="Subject" value={form.subject} onChange={e => setForm({ ...form, subject: e.target.value })} />
          <textarea className="w-full border rounded-lg px-3 py-2 min-h-32" placeholder="Write your message" value={form.text} onChange={e => setForm({ ...form, text: e.target.value })} />
          <button onClick={send} className="bg-emerald-700 text-white px-5 py-3 rounded-lg font-black">Send Mail</button>
        </div>
        <div className="space-y-3 max-h-80 overflow-auto">
          {messages.map(message => (
            <article key={message.id} className="border border-slate-200 rounded-lg p-3">
              <div className="flex justify-between gap-3">
                <b className="text-slate-900">{message.subject}</b>
                <span className="text-xs text-slate-500">{message.status}</span>
              </div>
              <p className="text-xs text-slate-500 mt-1">{message.from} → {message.to}</p>
              <p className="text-sm text-slate-700 mt-2 whitespace-pre-line">{message.text}</p>
            </article>
          ))}
          {!messages.length && <p className="text-slate-500">No mail yet.</p>}
        </div>
      </div>
    </section>
  );
};

export default DashboardMail;
